"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StreetViewOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M12,19h.22l.33,3,.35,3.12A2.14,2.14,0,0,0,15,27h2a2.14,2.14,0,0,0,2.1-1.88L19.78,19H20a2.51,2.51,0,0,0,2.05-1,2.48,2.48,0,0,0,.33-2.23l-1.25-4.17A4.37,4.37,0,0,0,18.66,9a4,4,0,1,0-5.32,0,4.37,4.37,0,0,0-2.47,2.66L9.62,15.8A2.48,2.48,0,0,0,10,18,2.51,2.51,0,0,0,12,19ZM16,4a2,2,0,1,1-2,2A2,2,0,0,1,16,4ZM11.53,16.37l1.25-4.17a2.29,2.29,0,0,1,1.56-1.46A13.38,13.38,0,0,1,16,10.65a13.38,13.38,0,0,1,1.66.09,2.29,2.29,0,0,1,1.56,1.46l1.25,4.17a.52.52,0,0,1,0,.47A.53.53,0,0,1,20,17H18l-.87,7.9A.17.17,0,0,1,17,25H15a.17.17,0,0,1-.12-.1L14,17H12a.53.53,0,0,1-.44-.16A.52.52,0,0,1,11.53,16.37Z"/><path d="M21.42,22.31l-.22,2A18.26,18.26,0,0,1,27.66,26c-1.35.83-5.39,2-11.66,2S5.69,26.83,4.34,26a18.26,18.26,0,0,1,6.46-1.71l-.22-2C5.54,22.92,2,24.34,2,26c0,2.21,6.27,4,14,4s14-1.79,14-4C30,24.34,26.46,22.92,21.42,22.31Z"/>';
var StreetViewOutlineSVG = function StreetViewOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.StreetViewOutlineSVG = StreetViewOutlineSVG;
StreetViewOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(StreetViewOutlineSVG);
exports.default = _default;